import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { Table } from "./Table";
import { Form } from "./Form";
import { IPermissionProps } from "../../../models/Login";
export interface IWorkstreamMasterDocument {
  id?: number;
  title?: string;
  doc_Description?: string;
  workstream_Category_ID?: number | null;
  doc_Path?: string | null;
  added_By?: number | null;
  added_On?: Date | null;
  updated_By?: number | null;
  updated_On?: Date | null;
}
export const EmptyWorkstreamMasterDocument = {
  id: undefined,
  title: "",
  doc_Description: "",
  workstream_Category_ID: null,
  doc_Path: "",
  added_By: null,
  added_On: null,
  updated_By: null,
  updated_On: null,
};
export interface IModel {
  open: boolean;
  singleData: IWorkstreamMasterDocument;
}

const RFPWorkstreamMasterDocuments = (permissions: IPermissionProps) => {
  const [modal, setModal] = useState({ singleData: EmptyWorkstreamMasterDocument, open: false } as IModel);
  const [reload, setReload] = useState<boolean>(false);
  const toast = useRef<any>(null);
  const hideDialog = () => {
    setModal({ singleData: EmptyWorkstreamMasterDocument, open: false });
  };

  return (
    <>
      <Table permission={permissions} reload={reload} setReload={setReload} setModel={setModal} toast={toast} />
      <Form singleData={modal.singleData} open={modal.open} setReload={setReload} hideDialog={hideDialog} toast={toast} reload={reload} />
      <Toast ref={toast} />
    </>
  );
};

export default RFPWorkstreamMasterDocuments;
